<template>
   
  <div class="third_plate">
    <div class="nav-header">
      <van-nav-bar :title="thirdInfoObj.name" @click-left="leftFn" left-arrow />
    </div>
    <div class="content_detail">
      <div class="content_tab">
        <van-tabs
          @click="tabContentClick"
          v-model="tabContentValue"
          title-active-color="#ff8340"
          title-inactive-color="#666"
          line-height="0"
          ref="tabInit"
        >
          <van-tab
            v-for="(item, ind) in tabContentTitle"
            :key="ind"
            :title="item"
          ></van-tab>
        </van-tabs>
      </div>
      <div class="content_area">
        <!-- <second-step
                    :branchList='thirdBranchList'
                    :showFirstContent='showFirstContent'
                /> -->
        <van-list
          style="margin-top: 10px"
          v-show="showthirdContent"
          ref="listContent"
          v-model="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="loadMore"
        >
          <second-step
            ref="secondStep"
            :showVideoPng="showVideoPng"
            :contentList="thirdBranchList"
            :showContent="showthirdContent"
          />
          <!-- 无数据展示 -->
          <no-datas v-if="dataExit" class="marginStyle" :dataExit="dataExit" />
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { _getColumnContents } from "@/api/parent-course";
import SecondStep from "@/components/parent-course/second-step.vue";
import { verticalScreen } from "@/assets/js/vertical-screen";
import NoDatas from "@/components/common/no-datas.vue";
export default {
  name: "third-plate",
  components: { SecondStep, NoDatas },
  props: {},
  data() {
    return {
      finishedText: "没有数据了哦！",
      NoDatas: false,
      dataExit: false,
      showthirdContent: true,
      thirdBranchList: [],
      thirdInfoObj: {},
      finished: false, //加载状态
      loading: false,
      showFirstContent: true,
      tabContentValue: JSON.parse(sessionStorage.getItem("thidrTabvalue")) || 0, //tab栏目菜单切换值 文章 视频
      tabContentTitle: ["视频", "文章"],
      contentParams: {
        asc: false,
        currentPage: 0,
        // orderByField: "createTime",
        pageSize: 5,
        queryData: {
          columnId: this.$storage.getStore("firstOtherPlateInfo").id,
          contentType: "VIDEO",
          putaway: true,
          tag: "家长",
        },
      },
    };
  },
  watch: {},
  computed: {
    showVideoPng() {
      //是否显示数据中vide.png图标
      // let { tabContentValue } = this;
      // let val = tabContentValue === 0 ? true : false;
      // return val;
      return false;
    },
  },
  methods: {
    // 根据id获取栏目下的内容

    leftFn() {
      sessionStorage.removeItem("thidrTabvalue");
      this.$router.back();
    },
    tabContentClick(val) {
      sessionStorage.setItem("thidrTabvalue", val);
      this.tabContentValue = val;
      this.$refs.listContent.check();
      // 重要！！！！ 需要重置加载状态
      this.loading = false;
      this.finished = false;
      this.thirdBranchList = [];
      if (this.tabContentValue === 0) {
        //视频
        this.$refs.listContent.check();
        // 重要！！！！ 需要重置加载状态
        this.loading = false;
        this.finished = false;
        this.contentParams.queryData.contentType = "VIDEO";
        this.contentParams.currentPage = 0;
        // 进入视频列表
        // this.$refs.secondStep.toVideo()
      } else if (this.tabContentValue === 1) {
        //文章
        this.$refs.listContent.check();
        // 重要！！！！ 需要重置加载状态
        this.loading = false;
        this.finished = false;
        this.contentParams.queryData.contentType = "PICTURE,FILE";
        this.contentParams.currentPage = 0;
      }
    },
    loadMore() {
      let { contentParams } = this;
      contentParams.currentPage += 1;
      this.getColumnContents(contentParams);
    },
    // 根据id获取栏目下的内容
    async getColumnContents(contentParams) {
      try {
        let res = await _getColumnContents(contentParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          //加载状态结束
          this.loading = false;
          // 合并第一次和第N次请求的书
          this.thirdBranchList = this.thirdBranchList.concat(data.records);
          if (this.thirdBranchList.length === 0) {
            this.showthirdContent = true;
            this.finishedText = "";
            this.dataExit = true;
          } else {
            this.showthirdContent = true;
            this.finishedText = "没有数据了哦！";
            this.dataExit = false;
          }
          //当数据全部加载完成
          if (data.records.length == 0) {
            this.finished = true;
          }
        } else {
          this.loading = false;
          // this.error = true
          Toast(message);
        }
      } catch (error) {}
    },
  },
  beforeCreate() {},
  created() {
    let info = this.$storage.getStore("firstOtherPlateInfo");
    this.thirdInfoObj = info;
    // 如果用户点击tab进入文章，那么从文章中再次返回到这个页面的时候，依然定位到文章tab上
    let sessTabValue = JSON.parse(sessionStorage.getItem("thidrTabvalue"));
    if (sessTabValue == 0 || !sessTabValue) {
      //tab定位于视频
      let { contentParams } = this;
      contentParams.queryData.contentType = "VIDEO";
      contentParams.currentPage = 0;
    } else {
      //tab定位于文章
      let { contentParams } = this;
      contentParams.queryData.contentType = "PICTURE,FILE";
      contentParams.currentPage = 0;
    }
  },
  beforeMount() {},
  mounted() {
    verticalScreen();
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {
    // this.$storage.removeStore('firstPlateInfo')
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
$active: "~@/assets/images/parent-course/active.png";
.third_plate {
  .nav-header {
    .van-nav-bar.van-hairline--bottom {
      position: fixed;
      width: 100%;
      background-color: #fff;
      z-index: 9999;
    }
  }
  .content_detail {
    padding-top: 45px;
    // display: flex;
    // justify-content: center;
    ::v-deep .van-tabs {
      background-color: #fff;
      z-index: 9999;
      width: 100%;
      position: fixed;
      padding-left: 7px;
    }
    ::v-deep.van-tabs__nav {
      width: 100px;
      .van-tab {
        .van-tab__text {
          font-size: 16px;
        }
        &.van-tab--active {
          position: relative;
          &::before {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0%;
            display: block;
            content: "";
            background: url($active) no-repeat;
            width: 22px;
            height: 7px;
            background-size: contain;
          }
        }
      }
    }
    .content_area {
      padding-top: 22px;
      display: flex;
      justify-content: center;
    }
  }
  .marginStyle {
    margin-top: 35%;
  }
}
</style>
